<template>
  <bj-modal
    v-model="visible"
    size="auto"
    title="Update inspection PDF"
  >
    <div slot="content">
      <div
        v-if="inspection.property"
        class="row gutter-sm"
      >
        <div class="col-12">
          <p>
            <b>Inspection id {{ inspection.id }} for {{ inspection.property.short_address }}.</b>
          </p>
          <p>
            Replacing the PDF will change the report PM's see on their web app, but no additional report emails will be sent.
          </p>
        </div>
        <div class="row gutter-sm">
          <q-field
            :error="get($v.payload, 'report_file.$error')"
            error-label="This field is required"
            class="col-6"
          >
            <input
              type="file"
              placeholder="Report file (PDF)"
              accept="application/pdf"
              @change="(event)=>payload.report_file=event.target.files[0]"
            >
          </q-field>
        </div>
      </div>
    </div>
    <div slot="footer">
      <q-btn-group
        rounded
        flat
      >
        <q-btn
          :disable="!payload.report_file || uploading"
          rounded
          color="primary"
          icon="save"
          size="lg"
          outline
          label="Upload"
          no-caps
          @click.prevent="submit"
        />
        <q-btn
          rounded
          color="primary"
          size="lg"
          outline
          label="Close"
          no-caps
          @click.prevent="close"
        />
      </q-btn-group>
    </div>
  </bj-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import get from 'lodash.get';

const defaultPayload = {
  report_file: null,
};

export default {
  name: 'ChangeInspectionPdfModal',
  validations() {
    return {
      payload: {
        report_file: { required },
      },
    };
  },
  data() {
    return {
      visible: false,
      uploading: false,
      inspection: {},
      payload: { ...defaultPayload },
      get,
    };
  },
  methods: {
    async show(inspection) {
      this.inspection = inspection;
      this.cleanModalState();
      this.$v.$reset();
      this.visible = true;
    },

    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.uploading = true;
      const formData = new FormData();
      for (const field in this.payload) {
        formData.append(field, this.payload[field]);
      }
      formData.append('_method', 'PUT'); // must be post because of the file
      this.api().request('POST', `admin/inspections/${this.inspection.id}/reports`, formData).then(() => {
        this.uploading = false;
        this.visible = false;
        this.uiNotify(`Report PDF updated for inspection ${this.inspection.id}`);
        this.cleanModalState();
        this.$emit('updated', this.inspection);
      }).catch((error) => {
        this.uploading = false;
        this.uiNotify(this.getFirstError(error) || error.message || 'Error occurred', 'negative', 5000);
      });
    },
    cleanModalState() {
      this.payload = { ...defaultPayload };
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
